//我的贷款-农户贷详情 不通过
<template>
  <div>
    <header-img :list="headerList"></header-img>
      <section class="main-block">
        <div class="top-title">我的贷款</div>

        <div class="status-wrap checkErrorBg">
          <div class="left">
            <div class="img-warp checkError">
              <img :src="statusImg" alt="" />
            </div>
            <div class="status">
              申请状态<br />
              <p v-if="status == 2">
                <span style="color:#EF5147 ;">{{statusCheck(status)}}</span>
                <span class="errorFont">请重新申请</span><br />
                <span style="font-size: 12px;" v-if="reason">不通过原因：{{reason}}</span>
              </p>
            </div>
          </div>
        </div>

        <div class="btn_wrap">    
          <el-button class="btns black" @click="$router.go(-1)">返回</el-button>
          <el-button class="btns red" @click="sumbitEvt()">重新申请</el-button>
        </div>
      </section>
  </div>
</template>

<script>
import DataUpload from '@/components/DataUpload/OneUpload.vue'
import ListUpload from '@/components/DataUpload/ListUpload.vue'
import HeaderImg from '@/components/HeaderImg'
import ErrorImg from '@/assets/img/check_error.png'
import LoadingImg from '@/assets/img/check_ing.png'
import SuccessImg from '@/assets/img/check_success.png'
import publicFunction from '@/utils/publicFunction'
import Upload from "@/components/Upload/UpLoad.vue";
import { sessionStore } from "@/utils/data-management";
export default {
  components: {
    DataUpload,
    ListUpload,
    HeaderImg,
    Upload
  },
  computed: {
    infoStatus() {
      return this.$store.state.infoStatus;
    }
  },
  data() {
    return {
      headerList: [
        { name: "产权流转交易中心", path: "/Home" },
        { name: "我的贷款", path: "/myLoan" },
        { name: "农户贷详情" }
      ],
      status: '',
      statusImg: ErrorImg,
      
      reason:"", //审核不通过的原因
      type:this.$route.query.type, // 1 是农户贷  2 是抵押贷款
    }
  },
  watch: {
  },
  created() {
    window.scrollTo(0, 0)
    this.status = this.$route.query.status + ''
    this.statusImg = ErrorImg
    this.getLoanDetail() // 获取详情信息
  },
  methods: {
    statusCheck(v) {
      switch (v) {
        // 状态（1：待审批；2：已拒绝；3：待补充资料；4：已通过）
        case '1':
          return '审批中'
          break
        case '2':
          return '未通过'
          break
        case '3':
          return '待补充资料'
          break
        case '4':
          return '已通过'
          break
        default:
          return ''
          break
      }
    },

     // 获取详情数据
    getLoanDetail(){
      const reasonArray = sessionStore.get('loanApproval');
      this.reason = reasonArray;
    },
    sumbitEvt(){
      if (this.infoStatus != 2 && this.infoStatus != 3) {
        sessionStore.set('bankId', this.$route.query.bankId)
        this.$goTo('infoCollection', 2)
      } else {
        this.$goTo('loanCollection')
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.main-block {
  .top-title {
    margin: 20px;
  }
  .status-wrap {
    width: 900px;
    height: 110px;
    display: flex;
    align-items: center;
    margin: 0 auto; 
    &.checkErrorBg {
      background: #fef0f2;
    }
    &.checkingBg {
      background: #fef9f0;
    }
    &.checkSuccessBg {
      background: #F0F9F0;
    }
    .left {
      display: flex;
      align-items: center;
      .status {
        margin-left: 35px;
        p {
          margin: 0;
          font-size: 20px;
          .errorFont {
            font-size: 16px;
            color: #60697e;
            padding-left: 15px;
          }
        }
      }
      .img-warp {
        width: 110px;
        height: 110px;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        &.checking {
          background: #ffaa36;
        }
        &.checkSuccess {
          background: #91A442;
        }
        &.checkError {
          background: linear-gradient(-135deg, #ff7067 0%, #ef5147 100%);
        }
        img {
          width: 40px;
          height: 40px;
          display: block;
        }
      }
    }
    
  }
  .h_bg {
    margin: 0 0 30px;
  }
  .btn_wrap {
    margin-right: 129px;
    margin-top: 210px;
    .el-button {
      border-radius: 2px;
    }
    .el-button + .el-button {
      margin-left: 20px;
    }
  }
}
</style>
